import React from 'react'
import Confirmation from '../../components/Host/Confirmation'
import { Container } from '../../components'

function ConfirmationPage() {
  return (
    <Container>
      <Confirmation />
    </Container>
  )
}

export default ConfirmationPage
